import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ENUM_ClientUserCreationMethod } from '@api-new/common';
import { WelcomeScreenInputModel, WelcomeScreenTemplateModel } from '@platform/dashboard/models/welcome-screen-template-model.model';
import { IconComponent } from '@shared-lib/components/icon/icon.component';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'cp-desktop-welcome-modal',
  templateUrl: './desktop-welcome-modal.component.html',
  styleUrls: ['./desktop-welcome-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IconComponent, ButtonModule],
})
export class DesktopWelcomeModalComponent {
  @Input() welcomeModalData: WelcomeScreenInputModel;
  @Output() skipButtonClick = new EventEmitter();
  showImportantModalScreen = false;
  step = 1;
  maxStep: number;
  progressRatio: number;

  private _modalTemplateData: WelcomeScreenTemplateModel[];

  get modalTemplateData(): WelcomeScreenTemplateModel[] {
    return this._modalTemplateData || [];
  }

  @Input()
  set modalTemplateData(data: WelcomeScreenTemplateModel[]) {
    this._modalTemplateData = data;
    this.maxStep = data.length;
    this.progressRatio = 100 / this.maxStep;
  }

  next(): void {
    if (this.step === this.maxStep) {
      return;
    }
    this.step++;
  }

  back(): void {
    if (this.step === 1) {
      return;
    }
    this.step--;
  }

  hideTutorialModal(): void {
    if (this.welcomeModalData.isExperianCompany) {
      this.finishTutorial();
      return;
    }
    this.showImportantModalScreen = true;
  }

  finishTutorial(): void {
    this.skipButtonClick.emit();
  }

  protected readonly ENUM_ClientUserCreationMethod = ENUM_ClientUserCreationMethod;
}
